import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=3cce2d23&scoped=true&"
import script from "./BaseForm.vue?vue&type=script&lang=js&"
export * from "./BaseForm.vue?vue&type=script&lang=js&"
import style1 from "./BaseForm.vue?vue&type=style&index=1&id=3cce2d23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce2d23",
  null
  
)

export default component.exports